import { ReactNode, useState } from 'react';
import { faAngleUp } from '@fortawesome/pro-light-svg-icons/faAngleUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

export interface IDropdownProps {
    title: ReactNode;
    children: ReactNode;
}

const Dropdown: React.FC<IDropdownProps> = ({ title, children }) => {
    const [opened, setOpened] = useState(true);
    return (
        <div>
            <button
                className={clsx(
                    'flex items-center justify-between w-full rounded-[6px] font-medium text-left cursor-pointer text-blueGray-600 bg-white hover:bg-opacity-70 hover:text-blueGray-500 text-[16px] leading-[24px] p-[12px]',
                    { 'rounded-br-[0px] rounded-bl-[0px]': opened },
                )}
                onClick={() => setOpened(!opened)}
                type="button"
            >
                {title}
                <FontAwesomeIcon
                    icon={faAngleUp}
                    className={clsx('!w-[24px] h-[24px]', { 'transform rotate-180': !opened })}
                />
            </button>
            {opened && (
                <div
                    className={clsx('bg-white pt-2', {
                        'rounded-br-[6px] rounded-bl-[6px]': opened,
                    })}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

export default Dropdown;
